import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmdbRegisterPageBondComponent } from './cmdb-register-page-bond.component';

@NgModule({
	declarations: [],
	imports: [CmdbRegisterPageBondComponent],
	exports: [CmdbRegisterPageBondComponent],
})
export class CmdbRegisterPageBondModule {}
